export const SHARE_COSTS = "share_costs"
export const INCLUDED_COSTS = "included_costs"
export const PAID_MISSION = "paid_mission"
export const PRO_ORG = "pro_org"
